// PlacesButton.js
var PlacesButton = pc.createScript('placesButton');

PlacesButton.attributes.add("CloseButton", {type: "entity"});
PlacesButton.attributes.add("Menu", {type: "entity"});

// initialize code called once per entity
PlacesButton.prototype.initialize = function() {

    this.entity.button.on('click', function(event){
        if (GameAnalyticsSdk.instance.gaStatus) {GameAnalytics("addDesignEvent", "PlacesButton:Click", 1);}
        PlaceManager.instance.initPlace();
        this.Menu.enabled = true;
    },this);

    this.CloseButton.button.on('click', function (event) {
        this.Menu.enabled = false;
    },this);

};


